import { GridColumnVisibilityModel } from '@mui/x-data-grid-premium'
import { GetControlledTableDefaultState } from '@omnea-app/fe-tables/ControlledTable/hooks/useControlledTableState'

export const BUYER_LEGAL_ENTITY_COLUMN_NAME = 'buyerLegalEntity'

export function getInitialColumnVisibilityModel(): GridColumnVisibilityModel {
  return {
    [BUYER_LEGAL_ENTITY_COLUMN_NAME]: false,
  }
}

export const getTasksTableDefaultState: GetControlledTableDefaultState = () => {
  return {
    columnVisibilityModel: getInitialColumnVisibilityModel(),
    sortModel: [{ field: 'dueDate', sort: 'asc' }],
  }
}
